import { StyledContainer } from "./styles";
import { ContainerProps } from "../types";

const HeaderContainer = ({ border, children }: ContainerProps) => (
  <StyledContainer border={border}>{children}</StyledContainer>
);

export default HeaderContainer;
